import React from 'react';
import { useBehaviorSubject } from '../../../utils/helpers';
import { OpponentIdleActionsDialog } from '../../game/model/interfaces';
import ModalWarning from './ModalWarning';

export default function ModalOpponentIdleActions(props: { dialog: OpponentIdleActionsDialog }) {
  const title = useBehaviorSubject(props.dialog.title);
  const message = useBehaviorSubject(props.dialog.message);
  const buttons = useBehaviorSubject(props.dialog.buttons);
  return <ModalWarning modal={{ title, body: message, buttons }} />;
}
